import { render, staticRenderFns } from "./ConstructionNewDocumentationSection.vue?vue&type=template&id=000c795b&scoped=true&lang=pug&"
import script from "./ConstructionNewDocumentationSection.vue?vue&type=script&lang=ts&"
export * from "./ConstructionNewDocumentationSection.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionNewDocumentationSection.vue?vue&type=style&index=0&id=000c795b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000c795b",
  null
  
)

export default component.exports